export function flipCardInit() {
    $('.card-flip').on('click', function(){
        let cardClass = $(this).hasClass('selected') ? null : 'selected'
        $('.card-flip.selected').removeClass('selected')
        if(cardClass) $(this).addClass('selected')
        else $(this).removeClass('selected')
    })
}